import React from "react";
import { Row, Col } from "react-bootstrap";

import Card from "../../../components/Card";
import TitlePage from "../../../components/TitlePage";
import WrapperContent from "../../../components/WrapperContent";

import { useLocalization } from "../../../../context/LocalizeContextProvider";
import Table from "../../../components/Table";
import { colorsAllergys, getGenderLabel } from "../../../../utils/constants";
import { formatOptionsToArray } from "../../../../utils/utils";
import PillItem from "../../../components/PillItem";

const ItemPatient = ({ label = "", value }) => {
  const isJsx = typeof value === "object";

  return (
    <Row>
      <Col md={5}>
        <p className="m-0 font-w500">{label} :</p>
      </Col>
      <Col>
        {isJsx ? (
          value
        ) : (
          <p className="m-0" style={{ textAlign: "end", fontWeight: 400 }}>
            {value}
          </p>
        )}
      </Col>
    </Row>
  );
};

export default function DetailPatientPackageComponents({
  activePackage = [],
  packageHistory = [],
  dataPatient = null,
  totalPage = 0,
  totalEntries = 0,
  sizePerPage = 0,
  activePage,
  sortState,
  setSortState,
  handleSetSizePerPage,
  handlePagination,
  isLoadingHistory = false,
}) {
  const localize = useLocalization();

  const columnsActivePackage = [
    {
      label: localize.getText("package"),
      key: "package_name",
      style: { fontSize: 14 },
    },
    {
      label: localize.getText("remainingNumberOfVisit"),
      key: "remaining_number_of_visit",
      style: { fontSize: 14 },
    },
    {
      label: localize.getText("lastReservation"),
      key: "lastReservation",
      style: { fontSize: 14 },
    },
    { label: localize.getText("price"), key: "price", style: { fontSize: 14 } },
    {
      label: localize.getText("discount"),
      key: "discount",
      style: { fontSize: 14 },
    },
    {
      label: localize.getText("subTotal"),
      key: "subTotal",
      style: { fontSize: 14 },
    },
  ];

  const columnsHistoryPackage = [
    {
      label: localize.getText("package"),
      key: "package_name",
      style: { fontSize: 14 },
    },
    {
      label: localize.getText("date"),
      key: "reservation_date",
      style: { fontSize: 14 },
      isSort: true,
    },
    { label: localize.getText("price"), key: "price", style: { fontSize: 14 } },
    {
      label: localize.getText("discount"),
      key: "discount",
      style: { fontSize: 14 },
    },
    {
      label: localize.getText("subTotal"),
      key: "subTotal",
      style: { fontSize: 14 },
    },
  ];

  return (
    <Card
      header={
        <TitlePage
          text={
            localize.getText("detail") +
            " " +
            localize.getText("patientPackage")
          }
          isBack
        />
      }
    >
      <div className="d-flex gap-3">
        <div style={{ width: "40%" }}>
          <WrapperContent color="default" title="Pasien" isShadow>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <ItemPatient
                label={localize.getText("medicalRecord")}
                value={dataPatient?.medicalRecordNumber}
              />
              <ItemPatient
                label={localize.getText("name")}
                value={dataPatient?.name}
              />
              <ItemPatient
                label={localize.getText("identityNumber")}
                value={dataPatient?.identificationNumber}
              />
              <ItemPatient
                label={localize.getText("gender")}
                value={getGenderLabel(dataPatient?.gender)}
              />
              <ItemPatient
                label={localize.getText("dateOfBirth")}
                value={dataPatient?.dateOfBirth}
              />
              <ItemPatient
                label={localize.getText("alergies")}
                value={
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      justifyContent: "flex-end",
                      flexWrap: "wrap",
                    }}
                  >
                    {formatOptionsToArray(dataPatient?.allergies || []).length >
                    0
                      ? formatOptionsToArray(dataPatient?.allergies).map(
                          (item, index) => (
                            <PillItem
                              text={item}
                              key={index}
                              bgColor={
                                colorsAllergys[index % colorsAllergys.length]
                              }
                            />
                          )
                        )
                      : "-"}
                  </div>
                }
              />
              <ItemPatient
                label={localize.getText("address")}
                value={dataPatient?.address}
              />
              <ItemPatient
                label={localize.getText("remark")}
                value={dataPatient?.remark}
              />
            </div>
          </WrapperContent>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 24,
            width: "59%",
          }}
        >
          <WrapperContent color="default" title="Paket Aktif" isShadow>
            <Table
              columns={columnsActivePackage}
              totalShow={activePackage.length}
              totalPage={1}
              activePage={1}
              totalEntries={activePackage.length}
              noPagination
            >
              {activePackage.map((item, index) => (
                <tr key={index}>
                  <td>{item.package_name}</td>
                  <td>{item.remaining_visits}</td>
                  <td>{item.last_reservation_date}</td>
                  <td>{item.price}</td>
                  <td>{item.dicount || "-"}</td>
                  <td>{item.sub_total || "0"}</td>
                </tr>
              ))}
            </Table>
          </WrapperContent>
          <WrapperContent color="default" title="History Paket" isShadow>
            <Table
              columns={columnsHistoryPackage}
              totalShow={packageHistory.length}
              totalPage={totalPage}
              activePage={activePage}
              totalEntries={totalEntries}
              handlePagination={handlePagination}
              sizePerPage={sizePerPage}
              handleSizePerPage={handleSetSizePerPage}
              sortState={sortState}
              setSortState={setSortState}
              loading={isLoadingHistory}
            >
              {packageHistory.map((item, index) => (
                <tr key={index}>
                  <td>{item.package_name}</td>
                  <td>{item.reservation_date}</td>
                  <td>{item.formatted_amount}</td>
                  <td>{item.formatted_discount || "-"}</td>
                  <td>{item.formatted_sub_total || "0"}</td>
                </tr>
              ))}
            </Table>
          </WrapperContent>
        </div>
      </div>
    </Card>
  );
}
